<template>
  <content-placeholders :rounded="true" class="loading-placeholder">
    <content-placeholders-text :lines="lines" />
  </content-placeholders>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingPlaceholder',
  props: {
    lines: {
      type: Number,
      default: 3,
    },
  },
})
</script>

<style lang="scss">
.loading-placeholder {
  width: 100%;
}
</style>
